import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import axios from 'axios'

const api = '/api/expense/'
const pref = 'expense-'

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error?.response?.data?.errors || null)
  }
}

export const Expenses = createAsyncThunk(`${pref}`, (_, thunkAPI) =>
  handleRequest(axios.get(`${api}list`), thunkAPI)
)

export const createExpense = createAsyncThunk(`${pref}create`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}store`, data), thunkAPI)
)

export const editExpense = createAsyncThunk(`${pref}edit`, (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}edit/${id}`), thunkAPI)
)

export const deleteExpense = createAsyncThunk(`${pref}delete`, (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}destroy/${id}`), thunkAPI)
)

export const createExpenseTrans = createAsyncThunk(`${pref}update-trans`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}update-transaction`, data), thunkAPI)
)

export const addSubCat = createAsyncThunk(`${pref}add-sub-cat`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}add-sub-cat`, data), thunkAPI)
)

export const approveTransaction = createAsyncThunk(`${pref}approve`, (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}approve/${id}`), thunkAPI)
)

export const deleteTransaction = createAsyncThunk(`${pref}destroy-item`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}destroy-item`, data), thunkAPI)
)

export const pendTransaction = createAsyncThunk(`${pref}pending`, (id: string, thunkAPI) =>
  handleRequest(axios.get(`${api}pending/${id}`), thunkAPI)
)

export const getStaff = createAsyncThunk(`${pref}get-staff`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}get-staff`, data), thunkAPI)
)

export const storeStaff = createAsyncThunk(`${pref}store-staff`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}store-staff`, data), thunkAPI)
)

export const editRecod = createAsyncThunk(`${pref}edit-record`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}edit-record`, data), thunkAPI)
)

export const printExpense = createAsyncThunk(`${pref}print`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}print`, data), thunkAPI)
)

export const emailExpense = createAsyncThunk(`${pref}email`, (data: {}, thunkAPI) =>
  handleRequest(axios.post(`${api}email`, data), thunkAPI)
)

export const ApproveCoursePayment = createAsyncThunk(
  `${pref}approve-course-payment`,
  (id: string, thunkAPI) => handleRequest(axios.get(`${api}approve-course-payment/${id}`), thunkAPI)
)

export const exportExpense = createAsyncThunk(`${pref}excel`, async (data: FormData) => {
  const response = await axios.post(`${api}excel`, data, {
    responseType: 'blob',
  })

  const blob = new Blob([response.data], {
    type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  })

  const url = window.URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = 'Annual_Expense_Report.xlsx'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  window.URL.revokeObjectURL(url)

  return true
})

type ExpenseState = {
  record: any
  records: any
  errors: any
}

const initialState: ExpenseState = {
  records: {data: []},
  record: {},
  errors: '',
}

export const expenseSlice = createSlice({
  name: 'expense',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: () => {},
})

export const {reset} = expenseSlice.actions
export default expenseSlice.reducer
